
import { useState } from "react";
import { ArrowDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";

interface HeroHeaderProps {
  visible: boolean;
}

export function HeroHeader({ visible }: HeroHeaderProps) {
  const [isHovered, setIsHovered] = useState(false);
  const isMobile = useIsMobile();

  return (
    <>
      <div className={`opacity-0 ${visible ? "animate-fade-in" : ""}`} style={{ animationDuration: "1s" }}>
        <div className="relative">
          <h1 id="hero-heading" className="text-2xl sm:text-3xl md:text-5xl leading-tight sm:leading-tight md:leading-tight font-serif font-light px-4 sm:px-6 md:px-0">
            The worst kind of success is the one that fills your bank account, while emptying your soul.
          </h1>
        </div>
      </div>
      
      <div className={`opacity-0 ${visible ? "animate-fade-in" : ""}`} style={{ animationDelay: "600ms", animationDuration: "1s" }}>
        <h2 
          className={cn(
            "text-base sm:text-lg md:text-xl tracking-wide md:tracking-wider font-sans text-center transition-all duration-400 mb-8 md:mb-10 px-4 sm:px-6 md:px-0",
            isHovered ? "text-charcoal" : "text-charcoal/70"
          )}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <span className="relative z-10">Sure, your achievements impress others,</span>
          <br className="hidden sm:block" />
          <span className="relative z-10">but they leave you with the nagging question:</span>
        </h2>
        
        <p className="mt-8 text-2xl sm:text-3xl md:text-4xl font-serif italic text-charcoal">Is there more?</p>
      </div>
      
      <div 
        className={`flex flex-col items-center mt-10 md:mt-14 opacity-0 ${visible ? "animate-fade-in" : ""}`} 
        style={{ animationDelay: "1000ms", animationDuration: "1s" }}
      >
        <span className="text-xs sm:text-sm font-sans uppercase tracking-widest text-charcoal/60 mb-3 md:mb-4">Explore</span>
        <ArrowDown 
          className="animate-bounce text-charcoal/60 mt-1" 
          size={isMobile ? 20 : 24}
        />
      </div>
    </>
  );
}
